/*
 * Ricerca delle stampanti per il configuratore consumabili.
 *
 * Un solo posto per: indice delle stampanti, ricerca per sigla, file di marca coi prodotti.
 * Lo usano la sezione configuratore-consumabili, la casella riusabile
 * (snippets/cerca-stampante.liquid) e il blocco nella ricerca del sito
 * (snippets/ricerca-stampante.liquid).
 *
 * Gli indirizzi dei file arrivano da window.__cfc, scritto da
 * snippets/cerca-stampante-config.liquid: va reso PRIMA di questo script.
 * L'indice (circa 360 KB) si scarica solo quando qualcuno lo chiede.
 */
(function() {
  'use strict';
  if (window.YepponStampanti) return;
  var CFG = window.__cfc || {};
  var COLORI = { nero: 1, ciano: 1, magenta: 1, giallo: 1, multicolore: 1 };
  // parole che la gente scrive insieme al modello e che non fanno parte del nome della stampante
  var VUOTE = { toner: 1, cartuccia: 1, cartucce: 1, inchiostro: 1, inchiostri: 1, nastro: 1, nastri: 1, tamburo: 1, tamburi: 1,
                stampante: 1, stampanti: 1, multifunzione: 1, per: 1, di: 1, la: 1, il: 1, un: 1, una: 1, originale: 1, originali: 1,
                compatibile: 1, compatibili: 1, ricambio: 1, ricambi: 1, nero: 1, nera: 1, ciano: 1, magenta: 1, giallo: 1,
                colore: 1, colori: 1, xl: 1 };
  var RX_CONSUMABILE = /\b(toner|cartucc|inchiostr|tambur|nastr[oi]|ink\b|drum\b)/i;

  var TUTTE = [], PER_CODICE = {}, PER_MARCA = {}, MARCHE = [];
  var promessaIndice = null, promesseMarca = {};

  function chiave(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sottotitolo(st) {
    var t = st.tec === 'Laser-Copy' ? 'laser' : st.tec === 'Inkjet' ? 'a getto d\'inchiostro' : '';
    return st.tipo + (t ? ' ' + t : '');
  }
  function traccia(nome, dati) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(nome, dati || {});
    } catch (e) { /* il tracciamento non deve mai rompere la pagina */ }
  }

  // ---- indice ---------------------------------------------------------------
  function indice() {
    if (!promessaIndice) {
      promessaIndice = fetch(CFG.indice).then(function(r) {
        if (!r.ok) throw new Error('indice ' + r.status);
        return r.json();
      }).then(function(dati) {
        (dati.b || []).forEach(function(m) {
          var slug = m[0];
          PER_MARCA[slug] = (dati.p[slug] || []).filter(function(r) { return r && r[0] && r[2]; }).map(function(r) {
            var st = { cod: String(r[0]), serie: r[1] || '', modello: String(r[2]), tipo: r[3] || 'Stampante', tec: r[4] || '', slug: slug, marca: m[1] };
            var nome = (st.marca + ' ' + st.modello).toLowerCase();
            st.km = chiave(st.modello);
            st.k = chiave(st.marca) + st.km;
            st.tok = nome.split(/\s+/).map(chiave).filter(Boolean);       // parole intere
            st.sub = nome.split(/[^a-z0-9]+/).filter(Boolean);            // anche i pezzi fra trattini
            TUTTE.push(st);
            PER_CODICE[st.cod.toUpperCase()] = st;
            return st;
          });
          MARCHE.push({ slug: slug, nome: m[1], quante: PER_MARCA[slug].length });
        });
        return { tutte: TUTTE, perCodice: PER_CODICE, perMarca: PER_MARCA, marche: MARCHE, generato: dati.g || '' };
      }).catch(function(e) { promessaIndice = null; throw e; });   // al prossimo tentativo si riprova a scaricare
    }
    return promessaIndice;
  }
  function stampante(cod) { return PER_CODICE[String(cod || '').toUpperCase()] || null; }

  // ---- ricerca --------------------------------------------------------------
  // Punteggio: 0 = la sigla scritta e' una parola intera del nome (o tutte le parole lo sono);
  // 0.5 = e' un pezzo fra trattini (2810 in ET-2810); 1 = inizio di una parola; 2 = inizio del nome;
  // 3 = ogni parola e' l'inizio di una parola; 4 = trovata solo a cavallo di due parole
  // ("et2810" dentro "DeskJET 2810e": senza questa regola vinceva lei).
  function punti(st, parole, tutto) {
    if (st.km === tutto || st.k === tutto || st.tok.indexOf(tutto) > -1) return 0;
    if (parole.length > 1 && parole.every(function(p) { return st.tok.indexOf(p) > -1; })) return 0;
    if (st.sub.indexOf(tutto) > -1) return 0.5;
    function inizia(p) { return function(t) { return t.indexOf(p) === 0; }; }
    if (st.tok.some(inizia(tutto)) || st.sub.some(inizia(tutto))) return 1;
    if (st.km.indexOf(tutto) === 0 || st.k.indexOf(tutto) === 0) return 2;
    if (parole.every(function(p) { return st.tok.some(inizia(p)) || st.sub.some(inizia(p)); })) return 3;
    return 4;
  }
  function trova(parole) {
    var trovate = [];
    for (var i = 0; i < TUTTE.length; i++) {
      var st = TUTTE[i], ok = true;
      for (var j = 0; j < parole.length; j++) if (st.k.indexOf(parole[j]) === -1) { ok = false; break; }
      if (ok) trovate.push(st);
    }
    return trovate;
  }
  function paroleDi(testo) {
    return String(testo || '').toLowerCase().split(/\s+/).filter(function(w) { return w && !VUOTE[w]; }).map(chiave).filter(Boolean);
  }
  // Da chiamare a indice caricato. null = testo troppo corto per cercare.
  function cerca(testo) {
    var parole = paroleDi(testo);
    if (!parole.length || parole.join('').length < 2) return null;
    var trovate = trova(parole), usate = parole, tolte = [];
    if (!trovate.length && parole.length > 1) {
      // niente con tutte le parole: si riprova senza quelle che non compaiono in nessuna stampante
      usate = parole.filter(function(p) { return TUTTE.some(function(st) { return st.k.indexOf(p) > -1; }); });
      tolte = parole.filter(function(p) { return usate.indexOf(p) === -1; });
      trovate = (usate.length && usate.join('').length >= 2) ? trova(usate) : [];
    }
    var tutto = usate.join('');
    var righe = trovate.map(function(st) { return { st: st, p: punti(st, usate, tutto) }; });
    righe.sort(function(a, b) { return a.p - b.p || a.st.k.length - b.st.k.length || a.st.k.localeCompare(b.st.k); });
    return { righe: righe, tolte: tolte, usate: usate, testo: String(testo || '').trim() };
  }
  // La sigla scritta corrisponde a UNA stampante precisa? (e' la sola condizione per scegliere da soli)
  function esatta(ricerca) {
    if (!ricerca) return null;
    var zero = ricerca.righe.filter(function(r) { return r.p === 0; });
    return zero.length === 1 ? zero[0].st : null;
  }
  // Numero sbagliato di poco ("hp 9030" quando esistono 9010, 9020, 9025): le stampanti col numero
  // piu' vicino, fra quelle che rispettano le altre parole scritte. Vuoto se non c'e' un numero da avvicinare.
  // Nella ricerca del sito serve almeno un'altra parola (marca o serie) e un numero di 4-5 cifre: quelli
  // di 3 cifre sono quasi sempre codici di cartucce (hp 903, epson 603). Con daSolo = true, cioe' dentro
  // una casella dove si sa gia' che si sta scrivendo una stampante, vanno bene anche da soli e di 3 cifre.
  function iniziaParola(st, p) {
    function inizia(t) { return t.indexOf(p) === 0; }
    return st.tok.some(inizia) || st.sub.some(inizia);
  }
  function vicine(testo, quante, daSolo) {
    var parole = paroleDi(testo);
    var numeri = parole.filter(function(p) { return (daSolo ? /^\d{3,5}$/ : /^\d{4,5}$/).test(p); });
    if (numeri.length !== 1) return [];
    var num = numeri[0], valore = parseInt(num, 10);
    var altre = parole.filter(function(p) { return p !== num && TUTTE.some(function(st) { return iniziaParola(st, p); }); });
    if (!altre.length && !daSolo) return [];
    var base = TUTTE.filter(function(st) { return altre.every(function(p) { return iniziaParola(st, p); }); });
    // il numero esiste davvero fra queste stampanti: non c'e' niente da avvicinare
    if (base.some(function(st) { return iniziaParola(st, num); })) return [];
    var soglia = num.length === 3 ? 10 : Math.max(30, valore * 0.02);
    var candidate = [];
    base.forEach(function(st) {
      var migliore = null;
      st.sub.forEach(function(t) {
        var m = /^[a-z]{0,3}(\d{3,5})[a-z]{0,4}$/.exec(t);
        if (m && m[1].length === num.length) {
          var d = Math.abs(parseInt(m[1], 10) - valore);
          if (migliore === null || d < migliore) migliore = d;
        }
      });
      // oltre il 2% di distanza non e' piu' "sbagliato di poco" (9030 -> 9010 si', 9030 -> 8600 no)
      if (migliore !== null && migliore <= soglia) candidate.push({ st: st, d: migliore });
    });
    candidate.sort(function(a, b) { return a.d - b.d || a.st.k.length - b.st.k.length || a.st.k.localeCompare(b.st.k); });
    return candidate.slice(0, quante || 8).map(function(c) { return c.st; });
  }
  function parlaDiConsumabili(testo) { return RX_CONSUMABILE.test(String(testo || '')); }
  // Una sigla: lettere e cifre nella stessa parola, almeno 5 caratteri (hl-l2350dw, et2810, m404dn).
  function haSigla(testo) {
    return String(testo || '').toLowerCase().split(/\s+/).some(function(w) {
      var k = chiave(w);
      return k.length >= 5 && /[a-z]/.test(k) && /\d/.test(k);
    });
  }
  // Vale la pena scaricare l'indice per questo testo? Solo se parla di consumabili o contiene una sigla.
  function daGuardare(testo) { return parlaDiConsumabili(testo) || haSigla(testo); }

  // Cosa dire a chi ha cercato questo testo nella ricerca del sito. Da chiamare a indice caricato.
  //   { caso: 'stampante', stampante, conParola }  una stampante precisa
  //   { caso: 'piu-stampanti', lista }             da 2 a 8 stampanti possibili
  //   { caso: 'numero-vicino', lista }             numero sbagliato di poco
  //   { caso: 'senza-modello' }                    si parla di consumabili ma il modello non c'e'
  //   null                                         niente da dire
  function riconosci(testo) {
    var conParola = parlaDiConsumabili(testo);
    var r = cerca(testo);
    // di un numero da solo non ci si fida: "toner 2420" e' il codice di un toner, non una stampante
    var conLettere = !!r && r.usate.some(function(p) { return /[a-z]/.test(p); });
    var unica = conLettere ? esatta(r) : null;
    // senza una parola come "toner" o "cartuccia" ci si fida solo di una sigla precisa:
    // "samsung s24" non deve far comparire le stampanti Samsung
    if (!conParola) return unica ? { caso: 'stampante', stampante: unica, conParola: false } : null;

    // se una parola e' stata scartata perche' non esiste (il numero 9030) le stampanti trovate sono
    // solo "tutte le HP": non e' una scelta sensata. Idem per quelle trovate a meta' parola (punteggio 4).
    var buone = (r && !r.tolte.length) ? r.righe.filter(function(x) { return x.p <= 3; }) : [];
    if (!unica && conLettere && buone.length === 1) unica = buone[0].st;
    if (unica) return { caso: 'stampante', stampante: unica, conParola: true };
    if (buone.length >= 2 && buone.length <= 8) return { caso: 'piu-stampanti', lista: buone.map(function(x) { return x.st; }) };
    var v = vicine(testo, 8);
    if (v.length) return { caso: 'numero-vicino', lista: v };
    // una sigla che non e' di nessuna stampante e' quasi sempre il codice di una cartuccia (903xl, tn2420):
    // chi la scrive sa gia' cosa vuole, la casella "parti dalla stampante" sarebbe solo rumore
    if (!buone.length && haSigla(testo)) return null;
    return { caso: 'senza-modello' };
  }

  // Dalla scheda di una stampante in vendita (titolo e marca) alla stessa stampante nell'indice.
  // Tutte le parole del modello devono stare nel titolo come parole intere; fra piu' candidate vince
  // il modello piu' lungo (LaserJet Pro M404dn batte LaserJet Pro). Serve almeno una parola con
  // lettere e cifre insieme: "HP 1220" si aggancerebbe a qualunque titolo con "1200 x 1220 dpi".
  // null se non c'e' o se due modelli diversi pareggiano.
  function daTitolo(titolo, marca) {
    var testo = String(titolo || '').toLowerCase(), parole = {}, elenco = [];
    testo.split(/\s+/).forEach(function(w) { w = chiave(w); if (w) { parole[w] = 1; elenco.push(w); } });
    function sigla(w) { return /[a-z]/.test(w) && /\d/.test(w); }
    // nel titolo la sigla a volte e' il codice del produttore, con la coda del paese: MFCL8340CDWRE1 per MFC-L8340CDW
    function conCoda(w) {
      return w.length >= 6 && elenco.some(function(t) { return t.indexOf(w) === 0 && t.length - w.length <= 3; });
    }
    var km = chiave(marca), trovate = [];
    TUTTE.forEach(function(st) {
      var ks = chiave(st.marca);
      if (km && ks.indexOf(km) !== 0 && km.indexOf(ks) !== 0) return;
      var mod = st.modello.toLowerCase().split(/\s+/).map(chiave).filter(Boolean);
      if (!mod.some(sigla)) return;
      if (!mod.every(function(w) { return parole[w] || (sigla(w) && conCoda(w)); })) return;
      trovate.push(st);
    });
    if (!trovate.length) return null;
    trovate.sort(function(a, b) { return b.km.length - a.km.length; });
    if (trovate.length > 1 && trovate[1].km.length === trovate[0].km.length && trovate[1].km !== trovate[0].km) return null;
    return trovate[0];
  }

  // ---- prodotti -------------------------------------------------------------
  function urlMarca(slug) {
    return (CFG.marche && CFG.marche[slug]) || String(CFG.indice || '').replace('consumabili-stampanti-data', 'consumabili-' + slug + '-data');
  }
  function caricaMarca(slug) {
    if (!promesseMarca[slug]) {
      promesseMarca[slug] = fetch(urlMarca(slug)).then(function(r) {
        if (!r.ok) throw new Error('catalogo ' + slug + ': ' + r.status);
        return r.json();
      }).catch(function(e) { delete promesseMarca[slug]; throw e; });
    }
    return promesseMarca[slug];
  }
  function prodotti(st) {
    return caricaMarca(st.slug).then(function(dati) {
      return (dati.m[st.cod] || []).map(function(i) { return dati.p[i]; }).filter(function(p) {
        return p && p[0] && p[1];  // una riga rotta non deve far saltare tutto l'elenco
      }).map(function(p) {
        var col = String(p[7] || '').toLowerCase();
        return { handle: p[0], title: p[1], brand: p[2], price: typeof p[3] === 'number' ? p[3] : null,
                 image: p[4] ? (String(p[4]).indexOf('http') === 0 ? p[4] : dati.img + p[4]) : '',
                 shipdays: (p[5] === null || p[5] === undefined || isNaN(Number(p[5]))) ? null : Number(p[5]),
                 tipo: p[6] || 'Altro', colore: COLORI[col] ? col : '', orig: p[8] === 1 };
      });
    });
  }
  var ORDINE_TIPO = { 'Toner': 0, 'Cartuccia': 0, 'Nastro': 0, 'Etichette': 0, 'Tamburo': 1, 'Testina': 2, 'Vaschetta': 3, 'Ricambio': 4, 'Altro': 5 };
  function ordTipo(t) { return ORDINE_TIPO[t] === undefined ? 5 : ORDINE_TIPO[t]; }
  function perPrezzo(a, b) { return (a.price === null ? 1e12 : a.price) - (b.price === null ? 1e12 : b.price); }
  // originali prima, poi toner e cartucce prima di tamburi e ricambi, poi dal meno caro
  // (per i clienti B2B, che i prezzi qui non li vedono, in ordine di nome)
  function consigliati(a, b) {
    return (b.orig - a.orig) || (ordTipo(a.tipo) - ordTipo(b.tipo))
      || (CFG.b2b ? a.title.localeCompare(b.title, 'it') : perPrezzo(a, b));
  }
  // Il numero a catalogo sono i giorni entro cui il pacco parte, non quelli di consegna.
  function spedizione(p) {
    if (p.shipdays === null) return '';
    return p.shipdays <= 0 ? 'Spedito in giornata' : p.shipdays === 1 ? 'Spedito entro 1 giorno lavorativo' : 'Spedito entro ' + p.shipdays + ' giorni lavorativi';
  }
  function prezzo(p) {
    if (CFG.b2b) return 'Vedi prezzo dedicato';
    return p.price !== null ? p.price.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) : '';
  }

  // ---- indirizzo del configuratore ------------------------------------------
  function urlPagina(cod, da) {
    var base = CFG.pagina || '/pages/configuratore-consumabili';
    var q = [];
    if (cod) q.push('stampante=' + encodeURIComponent(cod));
    if (da) q.push('da=' + encodeURIComponent(da));
    return base + (q.length ? (base.indexOf('?') > -1 ? '&' : '?') + q.join('&') : '');
  }

  // ---- casella riusabile (snippets/cerca-stampante.liquid) ------------------
  // Un campo solo: suggerisce le stampanti e alla scelta porta al configuratore gia' aperto su quella.
  function attivaCasella(radice) {
    if (radice.__attiva) return;
    radice.__attiva = true;
    var campo = radice.querySelector('input'), box = radice.querySelector('[data-sugg]');
    var contesto = radice.getAttribute('data-contesto') || '';
    var ultima = null, pronta = false;

    function chiudi() { box.hidden = true; campo.setAttribute('aria-expanded', 'false'); }
    function evidenzia(voce) {
      Array.prototype.forEach.call(box.querySelectorAll('a[data-cod]'), function(a) { a.classList.toggle('is-on', a === voce); });
      if (voce) voce.scrollIntoView({ block: 'nearest' });
    }
    function mostra() {
      if (!pronta) {
        if (campo.value) { box.innerHTML = '<div class="csb-msg">Carico l\'elenco delle stampanti…</div>'; box.hidden = false; }
        return;
      }
      var r = ultima = cerca(campo.value);
      if (r === null) { chiudi(); return; }
      var html = '';
      // numero sbagliato di poco, anche quando e' stato scartato e resterebbero "tutte le HP"
      var v = (!r.righe.length || r.tolte.length) ? vicine(campo.value, 8, true) : [];
      if (v.length) {
        html = '<div class="csb-msg">' + (r.tolte.length ? 'Non trovo “' + esc(r.tolte.join(' ')) + '”.' : 'Nessuna stampante con questo nome.') + ' Forse cercavi:</div>';
        v.forEach(function(st) { html += riga(st); });
      } else if (!r.righe.length) {
        html = '<div class="csb-msg">Nessuna stampante con questo nome. Prova con la sola sigla del modello.</div>';
      } else {
        r.righe.slice(0, 8).forEach(function(x) { html += riga(x.st); });
        if (r.righe.length > 8) html += '<div class="csb-msg">Altre ' + (r.righe.length - 8) + ': continua a scrivere</div>';
      }
      box.innerHTML = html;
      box.hidden = false;
      campo.setAttribute('aria-expanded', 'true');
    }
    function riga(st) {
      return '<a href="' + esc(urlPagina(st.cod, contesto)) + '" data-cod="' + esc(st.cod) + '">'
        + '<span><b>' + esc(st.marca) + '</b> ' + esc(st.modello) + '</span><small>' + esc(sottotitolo(st)) + '</small></a>';
    }
    function prepara() {
      indice().then(function() { pronta = true; if (document.activeElement === campo && campo.value) mostra(); })
        .catch(function() { box.innerHTML = '<div class="csb-msg">Non riesco a caricare l\'elenco delle stampanti.</div>'; box.hidden = false; });
    }
    campo.addEventListener('focus', function() { prepara(); if (campo.value) mostra(); });
    campo.addEventListener('input', function() { prepara(); mostra(); });
    campo.addEventListener('keydown', function(ev) {
      var voci = box.querySelectorAll('a[data-cod]'), attiva = box.querySelector('a.is-on');
      var pos = Array.prototype.indexOf.call(voci, attiva);
      if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
        if (box.hidden || !voci.length) return;
        ev.preventDefault();
        evidenzia(voci[ev.key === 'ArrowDown' ? (pos + 1) % voci.length : (pos <= 0 ? voci.length - 1 : pos - 1)]);
      } else if (ev.key === 'Enter') {
        if (box.hidden || !voci.length) return;
        ev.preventDefault();
        var unica = esatta(ultima);
        if (attiva) window.location.href = attiva.href;
        else if (unica) window.location.href = urlPagina(unica.cod, contesto);
        else evidenzia(voci[0]);
      } else if (ev.key === 'Escape') {
        chiudi();
      }
    });
    box.addEventListener('click', function(ev) {
      var a = ev.target.closest('a[data-cod]');
      if (a) traccia('Cerca Stampante Scelta', { codice: a.getAttribute('data-cod'), da: contesto });
    });
    document.addEventListener('click', function(ev) { if (!radice.contains(ev.target)) chiudi(); });
  }
  function attivaCaselle() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cerca-stampante]'), attivaCasella);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attivaCaselle);
  else attivaCaselle();

  window.YepponStampanti = {
    indice: indice, stampante: stampante, cerca: cerca, esatta: esatta, vicine: vicine, parlaDiConsumabili: parlaDiConsumabili,
    daGuardare: daGuardare, riconosci: riconosci, daTitolo: daTitolo,
    prodotti: prodotti, consigliati: consigliati, perPrezzo: perPrezzo, ordTipo: ordTipo, spedizione: spedizione, prezzo: prezzo,
    sottotitolo: sottotitolo, urlPagina: urlPagina, esc: esc, chiave: chiave, traccia: traccia,
    attivaCaselle: attivaCaselle, b2b: !!CFG.b2b
  };
})();
